import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Popover, Stack, styled, Typography } from '@mui/material';

interface FramePopoverProps {
  title: string;
  url: string;
  isOpen: boolean;
  onClose: () => void;
  anchor: HTMLElement | null;
}

const FrameHeader = styled(Stack, { name: 'FrameHeader' })(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  height: '3rem',
  padding: theme.spacing(1.5, 1),
  backgroundColor: theme.palette.custom.OV.sys.tertiaryContainer,
  [theme.breakpoints.up('sm')]: {
    borderBottom: `1px solid ${theme.palette.custom.OV.sys.outlineVariant}`,
  },
}));

export const FramePopover = ({ anchor, title, url, isOpen, onClose }: FramePopoverProps) => {
  return (
    <Popover
      open={Boolean(isOpen && anchor)}
      anchorEl={anchor}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <FrameHeader>
        <Typography
          sx={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
          flex="1"
          variant="subtitle2"
        >
          {title}
        </Typography>

        <IconButton color="inherit" onClick={onClose}>
          <CloseIcon color="inherit" />
        </IconButton>
      </FrameHeader>
      <iframe
        title={title}
        style={{
          height: '600px',
          width: '400px',
          margin: '0 -2px -2px',
          backgroundColor: 'white',
          border: 'none',
        }}
        src={url}
      />
    </Popover>
  );
};
